// ホバーサウンド（シュン）
(function() {
  var ctx = null;
  var lastPlayed = 0;

  function getCtx() {
    if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
    return ctx;
  }

  function playShun() {
    var now = Date.now();
    if (now - lastPlayed < 120) return;
    lastPlayed = now;

    var ac = getCtx();
    var duration = 0.12;
    var bufferSize = ac.sampleRate * duration;
    var buffer = ac.createBuffer(1, bufferSize, ac.sampleRate);
    var data = buffer.getChannelData(0);
    for (var i = 0; i < bufferSize; i++) data[i] = Math.random() * 2 - 1;

    var source = ac.createBufferSource();
    source.buffer = buffer;

    var filter = ac.createBiquadFilter();
    filter.type = 'bandpass';
    filter.frequency.value = 5000;
    filter.Q.value = 0.6;

    var gain = ac.createGain();
    gain.gain.setValueAtTime(0.0, ac.currentTime);
    gain.gain.linearRampToValueAtTime(0.15, ac.currentTime + 0.02);
    gain.gain.linearRampToValueAtTime(0.0, ac.currentTime + duration);

    source.connect(filter);
    filter.connect(gain);
    gain.connect(ac.destination);
    source.start(ac.currentTime);
  }

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('a, button, [role="button"]').forEach(function(el) {
      el.addEventListener('click', playShun);
    });

    var observer = new MutationObserver(function() {
      document.querySelectorAll('a, button, [role="button"]').forEach(function(el) {
        if (!el._shunBound) {
          el._shunBound = true;
          el.addEventListener('click', playShun);
        }
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();

// 仕組みボタン削除
(function() {
  function removeNioiBtn() {
    var sec = document.getElementById('shopify-section-sections--21714842976356__custom_liquid_jPBWKX');
    if (sec) sec.parentNode.removeChild(sec);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeNioiBtn);
  } else {
    removeNioiBtn();
  }
})();

// NEWS NEWバッジ
document.addEventListener("DOMContentLoaded", function() {
  var newsLinks = Array.from(document.querySelectorAll('a[href*="/blogs/"]')).slice(0, 1);
  newsLinks.forEach(function(link) {
    var badge = document.createElement('span');
    badge.textContent = 'NEW';
    badge.style.cssText = 'display:inline-block;font-size:9px;font-weight:700;letter-spacing:0.08em;color:#fff;background:#b8973a;border-radius:3px;padding:2px 5px;margin-left:6px;vertical-align:middle;position:relative;top:-1px;font-family:sans-serif;line-height:1;';
    link.appendChild(badge);
    var visible = true;
    setInterval(function() {
      visible = !visible;
      badge.style.opacity = visible ? '1' : '0.2';
    }, 700);
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll('.image-with-text__grid');

  // Dawnの既存アニメ無効化
  document.querySelectorAll('.scroll-trigger.animate--slide-in')
    .forEach(el => el.classList.remove('scroll-trigger', 'animate--slide-in'));

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        // セクション全体を表示
        entry.target.classList.add("show");

        // 画像とテキストを取得
        const media = entry.target.querySelector('.image-with-text__media-item');
        const text = entry.target.querySelector('.image-with-text__text-item');

        // 画像を先に出す
        if (media && !media.classList.contains("show")) {
          media.classList.add("show");
        }

        // テキストを0.3秒遅れて出す
        if (text && !text.classList.contains("show")) {
          setTimeout(() => text.classList.add("show"), 300);
        }
      }
    });
  }, { threshold: 0.2 });

  sections.forEach((el) => observer.observe(el));
});
